import { Skeleton } from "app/components/Skeleton";
import React from "react";
import { GroupAction } from "../../../../types";
import AddTicketGroupModal from "../../../Home/components/AddTicketGroupModal";
import RemoveGroupModal from "../../../Home/components/RemoveGroupModal";
import GroupHeaderBar from "./GroupHeaderBar";
import { GroupsProps } from "./types";

const Groups: React.FC<GroupsProps> = ({
  boardData,
  selectedTickets,
  group,
  loading,
  minTableWidth,
}) => {
  const [isRemoveGroup, setIsRemoveGroup] = React.useState(false);
  const [isGroupModalOpen, setIsGroupModalOpen] =
    React.useState<GroupAction | null>(null);

  const renderLoading = () => {
    return (
      <div className="!p-[10px] h-[30px] items-center flex flex-row">
        <Skeleton className="h-[20px] w-1/2 bg-gray-10 rounded-md" />
      </div>
    );
  };

  return (
    <React.Fragment>
      {loading ? (
        renderLoading()
      ) : (
        <div className="pe-[24px] ps-[52px]">
          <GroupHeaderBar
            boardData={boardData}
            selectedTickets={selectedTickets}
            group={group}
            minTableWidth={minTableWidth}
            setIsRemoveGroup={setIsRemoveGroup}
            setIsGroupModalOpen={setIsGroupModalOpen}
          />
        </div>
      )}

      {isRemoveGroup && (
        <RemoveGroupModal
          onClose={() => setIsRemoveGroup(false)}
          selectionCount={selectedTickets?.id?.length}
          groupTitle={group?.name}
          onSubmit={() => {}}
        />
      )}
      {isGroupModalOpen && (
        <AddTicketGroupModal
          onClose={() => setIsGroupModalOpen(null)}
          isEditGroup={isGroupModalOpen == GroupAction.EDIT ? true : false}
        />
      )}
    </React.Fragment>
  );
};

export default Groups;
